/* Built In Imports */

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/**
 *
 * @returns NoSeatingAvailable
 */
const NoSeatingAvailable = ({ name, price, discountedPrice }) => {
  let InrRupees = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  });
  return (
    <Box w="full">
      <Box
        flexDir="row"
        display="flex"
        fontFamily="FedraSansStd-medium"
        justifyContent="space-between"
      >
        <Box fontSize="14px" pl={6} color="rgb(255 255 255 / 38%)">
          {' '}
          {name}
        </Box>
        <Box fontSize="12px">
          {' '}
          {price > 0 && (
            <>
              <Text textAlign="right" color="rgb(255 255 255 / 38%)">
                {InrRupees.format(discountedPrice)
                  .replace('₹', 'INR ')
                  .replace('.00', '')}
              </Text>
              {discountedPrice != price && (
                <Text
                  as="span"
                  textDecoration="line-through"
                  fontFamily="FedraSansStd-medium"
                  //color={getColorForIndex(index)}
                  color="#9b9b9b"
                  textAlign="right"
                >
                  {InrRupees.format(price)
                    .replace('₹', 'INR ')
                    .replace('.00', '')}
                </Text>
              )}
            </>
          )}{' '}
        </Box>
      </Box>

      <Box
        flexDir="row"
        display="flex"
        fontFamily="FedraSansStd-medium"
        justifyContent="center"
        fontSize={{ base: '14px', md: '16px' }}
        color="#000"
      >
        CAPACITY REACHED
      </Box>
    </Box>
  );
};

export default NoSeatingAvailable;
